function createID(id) {
  return 'gauge' + id;
}

function markerID(id) {
  return 'marker' + id;
}

export { createID, markerID };



// WEBPACK FOOTER //
// ./src/lib/createID.js